package one.healthium.today.ui.carni.components

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Rect
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Outline
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.unit.Density
import androidx.compose.ui.unit.LayoutDirection

internal val headerShape = object : Shape {

    override fun createOutline(
        size: Size,
        layoutDirection: LayoutDirection,
        density: Density
    ): Outline {
        return Outline.Generic(
            path = createPath(size = size)
        )
    }

    private fun createPath(size: Size): Path {
        return Path().apply {
            val radius = size.width * 2.6f
            addOval(
                Rect(
                    center = Offset(size.width / 2, size.height - radius),
                    radius = radius,
                )
            )

            close()
        }
    }
}
